import { render } from "./clinic-doctor-dashboard.vue?vue&type=template&id=2ed39b89&scoped=true"
import script from "./clinic-doctor-dashboard.vue?vue&type=script&lang=js"
export * from "./clinic-doctor-dashboard.vue?vue&type=script&lang=js"

import "./clinic-doctor-dashboard.vue?vue&type=style&index=0&id=2ed39b89&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed39b89"]])

export default __exports__